import { FileSignature, ScrollText, IdCard, MapPin, Building2, User, PieChart, Scale, FileText, BarChart3, Landmark, Settings, Stamp } from 'lucide-react'
import { TabbedHub, type HubTab } from '@/components/TabbedHub'
import {
  AllFilingsPage, PayrollFilingsPage, ContractorFilingsPage, SalesFilingsPage,
  BusinessFilingsPage, PersonalFilingsPage,
  NexusTrackerPage, RateLookupPage, ExemptionCertsPage,
  ReconciliationPage, TaxDocumentsPage, TaxReportsPage,
  JurisdictionsPage, TaxSettingsPage,
} from './TaxPages'
import { TaxEstimatePage } from './TaxEstimatePage'

export function FilingsHub() {
  const tabs: HubTab[] = [
    { key: 'all', label: 'All Filings', icon: FileSignature, permission: 'tax.filings.view', element: <AllFilingsPage /> },
    { key: 'payroll', label: 'Payroll', icon: ScrollText, permission: 'tax.filings.view', element: <PayrollFilingsPage /> },
    { key: '1099', label: '1099 Contractors', icon: IdCard, permission: 'tax.filings.view', element: <ContractorFilingsPage /> },
    { key: 'sales', label: 'Sales Tax', icon: MapPin, permission: 'tax.sales.view', element: <SalesFilingsPage /> },
    { key: 'business', label: 'Business Income', icon: Building2, permission: 'tax.business.view', element: <BusinessFilingsPage /> },
    { key: 'personal', label: 'Personal (1040)', icon: User, permission: 'tax.personal.view', element: <PersonalFilingsPage />, smbHidden: true },
  ]
  return <TabbedHub tabs={tabs} />
}

export function SalesTaxHub() {
  const tabs: HubTab[] = [
    { key: 'nexus', label: 'Nexus Tracker', icon: MapPin, permission: 'tax.sales.nexus.view', element: <NexusTrackerPage /> },
    { key: 'rates', label: 'Rate Lookup', icon: PieChart, permission: 'tax.sales.view', element: <RateLookupPage /> },
    { key: 'exemptions', label: 'Exemption Certs', icon: Stamp, permission: 'tax.sales.exemptions.manage', element: <ExemptionCertsPage /> },
  ]
  return <TabbedHub tabs={tabs} />
}

export function ComplianceHub() {
  const tabs: HubTab[] = [
    { key: 'reconciliation', label: 'Reconciliation', icon: Scale, permission: 'tax.reconciliation.view', element: <ReconciliationPage /> },
    { key: 'documents', label: 'Documents', icon: FileText, permission: 'tax.documents.view', element: <TaxDocumentsPage /> },
    { key: 'reports', label: 'Reports', icon: BarChart3, permission: 'tax.reports.view', element: <TaxReportsPage /> },
    { key: 'estimate', label: 'Estimate', icon: PieChart, permission: 'tax.estimate.view', element: <TaxEstimatePage /> },
  ]
  return <TabbedHub tabs={tabs} />
}

export function TaxSetupHub() {
  const tabs: HubTab[] = [
    { key: 'taxpayers', label: 'Taxpayers', icon: Settings, permission: 'tax.settings.view', element: <TaxSettingsPage /> },
    { key: 'jurisdictions', label: 'Jurisdictions', icon: Landmark, permission: 'tax.jurisdictions.view', element: <JurisdictionsPage /> },
  ]
  return <TabbedHub tabs={tabs} />
}
